import modalFn from '../../styles/objects/modal'

export default ({ colors, spacings, images, fontWeights }) => {
  const modal = modalFn({ colors, spacings, images, fontWeights })

  const styles = {
    'selfie-content': {
      position: 'fixed',
      zIndex: '110',
      top: '50%',
      left: '50%',

      width: '704px',
      height: '704px',
      marginTop: '-352px',
      marginLeft: '-352px',
      padding: '2rem',

      borderRadius: '4px',
      backgroundColor: colors.modal.selfie.bg
    },

    'selfie-content--novideo': {
      height: '200px',
      marginTop: '-100px'
    },

    screenshot: {
      display: 'block',
      marginTop: '2rem',
      maxWidth: '500px',
      maxHeight: '500px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },

    'selfie-buttons': {
      textAlign: 'center',

      ':not(.foo) button:not(:first-child)': {
        marginLeft: '50px'
      }
    }
  }

  return { ...modal, ...styles }
}



// WEBPACK FOOTER //
// ./components/webcammodal/styles.js